import Immutable, { fromJS } from 'immutable';
import { LOCATION_CHANGE } from 'connected-react-router';
import * as types from './actionTypes';
import initialState from '../../Store/initialState';
import { getPathName, getAuthorization, extractErrorMessages } from '../../Utils/Utils';

import { locale } from '../Tools/reducers';
import * as systemTypes from '../System/actionTypes';

let newState;
let redirectTo;
const Auth = (state = initialState.get('auth'), action) => {
  try {
    switch (action.type) {
      // LOCALE
      case systemTypes.FETCH_USER_LANGUAGE: {
        return state.set('strings', locale(action?.data?.language, 'login'));
      }

      case types.LOGOUT:
        newState = state.set('loading', false);
        newState = newState.set('isAuthenticated', false);
        newState = newState.set('isReset', false);
        newState = newState.set('isChanged', false);
        newState = newState.set('ready', false);

        if (action.alerts) {
          newState = newState.setIn(['alerts', 'errors'], fromJS(extractErrorMessages(action.alerts)));
        }

        localStorage.setItem('auth', JSON.stringify(newState));
        return newState;

      case LOCATION_CHANGE: {
        redirectTo = getPathName(action.payload.location) || '/';
        newState = state.set('redirectTo', redirectTo.includes('login') ? '/' : redirectTo);
        return newState;
      }

      case types.FETCH_USERINFO_REQUEST:
        newState = state.set('ready', true);
        return newState;

      case types.FETCH_USERINFO_SUCCESS:
        newState = state.set('userInfo', Immutable.fromJS(action.data));
        newState = newState.set('ready', true);
        newState = newState.setIn(['alerts', 'errors'], []);
        localStorage.setItem('auth', JSON.stringify(newState));
        return newState;

      case types.FETCH_USERINFO_FAIL:
        newState = state.set('ready', true);
        newState = newState.setIn(['alerts', 'errors'], fromJS(extractErrorMessages(action.error)));
        return newState;

      // AUTHORIZATION INFO
      case types.FETCH_AUTHORIZATION_INFO_REQUEST: {
        return state;
      }

      case types.FETCH_AUTHORIZATION_INFO_SUCCESS: {
        newState = state.mergeDeep(
          state,
          fromJS({
            info: { ...action.data },
            ready: true,
          })
        );
        // Reset errors messages in local storage
        // So when you refresh, it doesn't show old messages
        const localState = state.setIn(['alerts', 'errors'], []);
        localStorage.setItem('auth', JSON.stringify(localState));
        return newState;
      }

      case types.FETCH_AUTHORIZATION_INFO_FAIL: {
        newState = state.mergeDeep(
          state,
          fromJS({
            ready: true,
          })
        );
        newState = newState.setIn(['alerts', 'errors'], fromJS(extractErrorMessages(action.error)));
        // Reset errors messages in local storage
        // So when you refresh, it doesn't show old messages
        const localState = state.setIn(['alerts', 'errors'], []);
        localStorage.setItem('auth', JSON.stringify(localState));
        return newState;
      }

      // AUTHORIZATION LOGIN
      case types.FETCH_AUTHORIZATION_LOGIN_REQUEST: {
        newState = state.set('isAuthenticated', false).set('isFetching', true).set('inError', false);
        return newState;
      }

      case types.FETCH_AUTHORIZATION_LOGIN_SUCCESS: {
        redirectTo = getPathName(state.get('redirectTo')) || '';
        newState = state
          .set('loading', false)
          .set('redirectTo', redirectTo.includes('login') ? '/' : redirectTo)
          .set('isAuthenticated', true)
          .set('isFetching', false)
          .set('authorization', getAuthorization(action.data.headers))
          .set('inError', false);
        localStorage.setItem('auth', JSON.stringify(newState));
        return newState;
      }

      case types.FETCH_AUTHORIZATION_LOGIN_FAIL: {
        newState = state
          .set('userInfo', false)
          .set('isAuthenticated', false)
          .set('isFetching', false)
          .set('inError', true);
        newState = newState.setIn(['alerts', 'errors'], fromJS(extractErrorMessages(action.error)));
        return newState;
      }

      case types.POST_RESET_PASSWORD_REQUEST: {
        return state.set('loading', true);
      }

      case types.POST_RESET_PASSWORD_SUCCESS: {
        return state.set('isReset', true).set('loading', false);
      }

      case types.POST_RESET_PASSWORD_FAIL: {
        newState = state.setIn(['alerts', 'errors'], fromJS(extractErrorMessages(action.error)));
        newState = newState.set('loading', false);
        return newState;
      }

      case types.POST_CHANGE_PASSWORD_REQUEST: {
        return state.set('loading', true);
      }

      case types.POST_CHANGE_PASSWORD_SUCCESS: {
        newState = state.set('redirectTo', '/');
        newState = newState.set('isChanged', true).set('loading', false);
        return newState;
      }

      case types.POST_CHANGE_PASSWORD_FAIL: {
        newState = state.setIn(['alerts', 'errors'], fromJS(extractErrorMessages(action.error)));
        newState = newState.set('loading', false);
        return newState;
      }

      default:
        return state;
    }
  } catch (e) {
    console.log(e.stack);
    return state;
  }
};

export default Auth;
